import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface RoleBasedRouteProps {
    allowedRoles: string[];
    children?: React.ReactNode;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ allowedRoles, children }) => {
    const userRole = localStorage.getItem('user_role');
    
    console.log('RoleBasedRoute:', { userRole, allowedRoles });
    
    if (!userRole) {
        console.log('No user role found, redirecting to login');
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(userRole)) {
        console.log('User role not allowed, redirecting to dashboard');
        
        // Redirect to the appropriate dashboard based on user role
        if (userRole === 'super' || userRole === 'consultant') {
            return <Navigate to="/consultant/dashboard" replace />;
        } else if (userRole === 'client' || userRole === 'client_admin') {
            return <Navigate to="/dashboard" replace />;
        }
        
        // Default fallback
        return <Navigate to="/" replace />;
    }

    console.log('Role check passed, rendering content');
    return children ? <>{children}</> : <Outlet />;
};

export default RoleBasedRoute; 